module.exports = __webpack_public_path__ + "img/secure-images.b1a75043.png";